import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ScottyIntegration = () => {
  return (
    <section className="py-24 bg-slate-950 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6 leading-tight">
              A Wider Audience <br />
              <span className="text-violet-400">On Every Channel.</span>
            </h2>
            <p className="text-slate-400 text-lg mb-12 leading-relaxed">
              Scotty doesn't just live on your website. 
              <strong> Integrate with Messenger, WhatsApp and directly to you Event Page for a wider audience.</strong> 
              Provide a seamless support experience across the entire social web.
            </p>

            <div className="space-y-6">
              {[
                { title: "WhatsApp Business", desc: "Automate inquiries on the world's most popular messaging app." },
                { title: "Facebook Messenger", desc: "Convert social interest into ticket sales instantly." },
                { title: "Native Event Embed", desc: "Keep attendees on your page with persistent AI support." }
              ].map((item, i) => (
                <div key={i} className="flex gap-4 p-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                  <div className="flex-shrink-0 mt-1">
                    <div className="bg-violet-500/20 rounded-lg p-2">
                      <SafeIcon icon={FiIcons.FiCheck} className="w-5 h-5 text-violet-400" />
                    </div>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">{item.title}</h4>
                    <p className="text-slate-400 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-slate-900 rounded-3xl p-8 border border-white/10 shadow-2xl relative z-10">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 bg-violet-600 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiIcons.FiCpu} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-white">Scotty AI</h3>
                  <p className="text-xs text-violet-400 uppercase tracking-widest font-bold">Online & Learning</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white/5 p-4 rounded-2xl border border-white/5 max-w-[80%]">
                  <p className="text-sm text-slate-300">"How do I access the VIP lounge at the expo?"</p>
                </div>
                <div className="bg-violet-600/20 p-4 rounded-2xl border border-violet-500/30 ml-auto max-w-[80%]">
                  <p className="text-sm text-white">"I've checked your ticket! You can access the VIP lounge via Gate 4. Would you like me to send a map to your WhatsApp?"</p>
                </div>
                <div className="pt-4 flex justify-between items-center text-[10px] text-slate-500 font-bold uppercase tracking-widest border-t border-white/5">
                  <span>Lead Enriched</span>
                  <span className="text-violet-400">Ready for Export</span>
                </div>
              </div>
            </div>
            
            {/* Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-violet-600/20 blur-[120px] -z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScottyIntegration;